import * as Yup from 'yup';

export const bannerFormSchema = Yup.object().shape({
    title: Yup.string().max(255, 'Title must be 255 characters or less').required('Title is required'),
    message: Yup.string().max(2000, 'Message must be 2000 characters or less').required('Message is required'),
    type: Yup.string()
        .oneOf(['info', 'success', 'warning', 'error'])
        .required('Type is required'),
    linkText: Yup.string()
        .max(100, 'Link text must be 100 characters or less')
        .nullable()
        .when('linkUrl', {
            is: (val: string | null) => Boolean(val),
            then: (schema) => schema.required('Link text is required when a URL is provided'),
        }),
    linkUrl: Yup.string()
        .max(2000, 'Link URL must be 2000 characters or less')
        .nullable()
        .matches(/^https?:\/\/.+/i, {
            message: 'Link URL must start with http:// or https://',
            excludeEmptyString: true,
        })
        .when('linkText', {
            is: (val: string | null) => Boolean(val),
            then: (schema) => schema.required('Link URL is required when link text is provided'),
        }),
    priority: Yup.number()
        .integer('Priority must be a whole number')
        .required('Priority is required'),
    allowDontShowAgain: Yup.boolean().required(),
    targetAllOrgs: Yup.boolean().required(),
    targetSubscriptionIds: Yup.array()
        .of(Yup.string())
        .when('targetAllOrgs', {
            is: false,
            then: (schema) => schema.min(1, 'Select at least one subscription'),
            otherwise: (schema) => schema.optional(),
        }),
    isActive: Yup.boolean(),
    startsAt: Yup.string().nullable().optional(),
    expiresAt: Yup.string()
        .nullable()
        .optional()
        .test(
            'after-startsAt',
            'Expiry must be after start time',
            function (value) {
                const { startsAt } = this.parent;
                if (startsAt && value) {
                    return new Date(value) > new Date(startsAt);
                }
                return true;
            },
        ),
}, [['linkText', 'linkUrl']]);
